import React from 'react';
import cn from '../../../../lib/bem';
import ico_cancel_circle from './../../../../assets/svg/ico_cancel_circle.svg';

import './modalNotasImportantes_Component.scss';

const ModalNotasImportantesComponent = (props) => {

    const classes  = cn("modalNotasImportantesComponent");
  
    return (
        <div className={classes()}> 
            <div className={classes('container')}>
                <div className={classes('content')}>
                    <div className={classes('contentForm')}>
                        <img className={classes('contentClose')} src={ico_cancel_circle} alt={'ico_cancel_circle'} onClick={ () => props.onClose(false)}/>
                        <p className={classes('contentTitle')}><b>Notas importantes</b></p>
                        <div>
                            <ul>
                                <li>Las estimaciones presentadas en este documento tienen validez de 7 días calendario. Pasado ese plazo, dejan de estar vigentes y deben ser cotizadas nuevamente estando sujetas a variaciones de mercado.</li>
                                <li>Las primas de seguros de vida emitidas a favor de personas naturales residentes en el Perú están inafectas al IGV.</li>
                                <li>Las ganancias obtenidas en los seguros de vida se encuentran exoneradas del impuesto a la renta hasta el 31 de diciembre de 2026 de acuerdo con lo dispuesto en el Decreto Supremo N° 179-2004-EF, modificado por el Decreto Legislativo N° 1549. Dicha exoneración se mantendrá vigente en tanto sea renovada.</li>
                                <li>Para el Seguro de Vida y el Beneficio por Fallecimiento se excluye el fallecimiento del Asegurado a consecuencia de un acto criminal en el que resulte responsable un beneficiario. En dicho supuesto, el beneficio que correspondía se pagará a los otros beneficiarios restantes en proporción a la participación que les fuese asignada.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalNotasImportantesComponent;